import { useDataFormat } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let ids = useDataFormat({
    viewPath: props.viewPath,
    context: 'manual_action_execution_ids',
    format: value => value.map(item => item.id),
  })

  return {
    variables: { ids },
    pause: ids.length === 0,
  }
}
